// extracted by mini-css-extract-plugin
export var Layout = "b_b";
export var aniBgLoading = "b_f";
export var aniSpin = "b_d";
export var main = "b_c";